import {
    QUERY_PROFILE_REQUEST,
    QUERY_PROFILE_FAIL,
    QUERY_PROFILE_SUCCESS
} from "../../types"

const initialState = {
    isLoading: false,
    message: '',
    queryData: {}
}

export const queryReducer = (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
        case QUERY_PROFILE_REQUEST:
            return {
                ...state,
                isLoading: false
            };
        case QUERY_PROFILE_SUCCESS:
            return {
                ...state,
                projects: payload,
                isLoading: true
            };
        case QUERY_PROFILE_FAIL:
            return {
                ...state,
                message: payload,
                isLoading: false
            };
        default:
            return state;
    }
}